__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ht7-lms-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "20.3.27", () => (__webpack_require__.e(15).then(() => (() => (__webpack_require__(8015))))));
			register("@angular/common", "20.3.27", () => (__webpack_require__.e(610).then(() => (() => (__webpack_require__(7610))))));
			register("@angular/core/rxjs-interop", "20.3.27", () => (__webpack_require__.e(74).then(() => (() => (__webpack_require__(9074))))));
			register("@angular/core", "20.3.27", () => (__webpack_require__.e(699).then(() => (() => (__webpack_require__(5699))))));
			register("@angular/platform-browser", "20.3.27", () => (__webpack_require__.e(55).then(() => (() => (__webpack_require__(436))))));
			register("@angular/router", "20.3.27", () => (__webpack_require__.e(39).then(() => (() => (__webpack_require__(6039))))));
			register("@primeuix/styled", "0.7.4", () => (__webpack_require__.e(68).then(() => (() => (__webpack_require__(5687))))));
			register("rxjs/operators", "7.8.2", () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(3620))))));
			register("rxjs", "7.8.2", () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(1340))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};